/**
 * Host-only availability troubleshoot/debug on public booking pages.
 * Visible when an admin/staff session exists in localStorage and matches the event business.
 */
export const canShowBookingAvailabilityDebug = (event = null) => {
  if (typeof window === "undefined") {
    return false;
  }

  const token = localStorage.getItem("jwtToken");
  if (!token) {
    return false;
  }

  try {
    const configRaw = localStorage.getItem("config");
    if (!configRaw) {
      return false;
    }

    const config = JSON.parse(configRaw);
    if (!config?.user) {
      return false;
    }

    if (event?.business_id != null) {
      const storedBusinessId = localStorage.getItem("businessId");
      if (
        storedBusinessId &&
        String(storedBusinessId) !== String(event.business_id)
      ) {
        return false;
      }
    }

    return true;
  } catch (error) {
    return false;
  }
};
